import * as React from "react";
import styled from "styled-components";

import { Icon } from "./Icon";
import { Image } from "./Image";

interface AvatarProps {
  src?: string | null;
  alt?: string;
  className?: string;
  size?: number;
  defaultIcon?: React.ReactChild;
}

export const Avatar = (props: AvatarProps) => {
  return (
    <AvatarWrapper
      tips={{ error: "" }}
      size={32}
      defaultIcon={<Icon type={"default-avatar"} />}
      {...props}
    />
  );
};

const AvatarWrapper = styled(Image)<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 100%;
  border: 1px solid ${(props) => props.theme.gray};
  flex: none;
  &.image-background {
    background: transparent;
    border: none;
  }
  i {
    font-size: ${(props) => props.size}px;
    color: ${(props) => props.theme.textDeepGray};
  }
`;
